import React, { Component } from 'react'
import Header from '../../Common/Header'
import { Flex } from 'hljd'
import { observer, inject } from 'mobx-react'
import style from './style.module.less'
import cls from 'classnames'
import { dGet } from '@core/utils'
import Img from '@UI/Img'
import Store from './store'

@inject('decorationStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.store)
  }

  render() {
    const { tab, changeTab } = this.store
    let {
      decorationStore: { newThemeConfig },
      data: { list, video_count },
      store: { totalAll }
    } = this.props
    list = list || []
    const { tabSelectedBg, tabBg, tabSelectedText, tabText } = newThemeConfig
    const selectedAll = tab === 'all'
    const selectedVideo = tab == 'video'
    return (
      <>
        <Header title="动态" />

        {totalAll > 0 ? (
          <>
            {totalAll > 1 && (
              <Flex>
                <div
                  className={cls(style.tab)}
                  onClick={() => changeTab('all')}
                  style={{
                    background: selectedAll ? tabSelectedBg : tabBg,
                    color: selectedAll ? tabSelectedText : tabText
                  }}
                >
                  所有动态{totalAll}
                </div>
                <div
                  className={cls(style.tab)}
                  onClick={() => changeTab('video')}
                  style={{
                    background: selectedVideo ? tabSelectedBg : tabBg,
                    color: selectedVideo ? tabSelectedText : tabText
                  }}
                >
                  视频{video_count}
                </div>
              </Flex>
            )}

            <div className={style.waterfall}>
              {list.map(item => {
                const { id, like_count, title, note_type, cover } = item
                const isVideo = note_type == 3
                const cover_path = isVideo
                  ? dGet(cover, 'video.cover_path')
                  : dGet(cover, 'photo.cover_path')
                return (
                  <div key={id} className={style.item}>
                    <img src={cover_path} className={style.cover} />

                    <div className={style.info}>
                      <div className={style.title}>{title}</div>

                      <Flex className={style.content} sp>
                        <Flex vc>
                          <Img
                            src={
                              dGet(item, 'user.avatar') ||
                              dGet(item, 'user.default_avatar')
                            }
                            style={{ width: 18, height: 18, flexShrink: 0 }}
                            className={style.avatar}
                          />

                          <span className={cls(style.name, 'text-cut')}>
                            {dGet(item, 'user.nick')}
                          </span>
                        </Flex>

                        <Flex vc>
                          <img
                            className={style.like}
                            src="//qnm.hunliji.com/o_1dn42jhmvifda9f1qg989j1ca9.png"
                          />
                          <span>{like_count}</span>
                        </Flex>
                      </Flex>
                    </div>
                  </div>
                )
              })}
            </div>
          </>
        ) : (
          <Flex style={{ height: 100 }} vc hc>
            暂无动态，快去发布吧~
          </Flex>
        )}
      </>
    )
  }
}
